import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {AndroidIcon, IphoneIcon, GameIcon, CustomSoftIcon, SoftwareProIcon, SoftwareMainIcon} from "../../../app-constants";
import { Link } from 'gatsby'; // Import Gatsby's Link component
import HtmlParser from 'react-html-parser';


const StackItem = [
    {
        icon: AndroidIcon,
        title: 'Android app development',
        description: (
            <>
                Boost your{' '}
                <Link to="/android-app-development" rel="noopener" aria-label="TekRevol">
                    Android app development
                </Link> {' '}
                experience with TekRevol, exploiting the world's most extensively used medium with native apps. Our tech stack of Java or Kotlin repurposes your app perceptions with meticulousness and inspiration, completely designed for the Florida market.
            </>
        ),

    },
    {
        icon: IphoneIcon,
        title: 'Iphone app development',
        description: (
            <>
                Raise your iOS experience with TekRevol's{' '}
                <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
                    iPhone app development,
                </Link> {' '}
                offering sophisticated, seamlessly functional native apps. We precisely examine every feature, guaranteeing your app effortlessly aligns with Apple's design principles and ideologies.
            </>
        ),

    },
    {
        icon: GameIcon,
        title: 'Game app development',
        description: (
            <>
                Dive into the profitable gaming industry with TekRevol's{' '}
                <Link to="/game-development" rel="noopener" aria-label="TekRevol">
                    mobile game development,
                </Link> {' '}
                offering highly engaging and monetization-ready games for your business endeavor. Expert in various categories such as shooting, arcade, RPG, and strategy, we can bring any game idea you imagine to life in the dynamic Florida market.
            </>
        ),

    },
    {
        icon: CustomSoftIcon,
        title: 'Custom Software Development',
        description: (
            <>
                Modified software solutions are squarely created to satisfy your detailed business requirements, warranting ideal functionality and success. As a top-class{' '}
                <Link to="/custom-software-development" rel="noopener" aria-label="TekRevol">
                    custom software development company,
                </Link> {' '}
                TekRevol arms your software projects with wide-ranging skills and plentiful resources, nurturing modernization and output personalized for businesses in Florida
            </>
        ),
    },
    {
        icon: SoftwareProIcon,
        title: 'Software Product Development',
        description:"We offer scalable software product development, routing market success through originality and progressive technology. TekRevol has dedicated itself to strong SaaS, mobile, and desktop software products, offering superlative user experiences handmade for Florida's business ecosystem.",
    },
    {
        icon: SoftwareMainIcon,
        title: 'Software Support and Maintenance',
        description: "Unswerving support and maintenance services, guaranteeing faultless operations and permanency of your software products. We provide assurance for unimpeachable functionality and flexibility through nonstop performance monitoring, augmentations, feature developments, and problem resolution.",
    },

];

function Improvise(props) {
    return (
        <div className="improvise_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                <Col xs={12} md={12} lg={12} xl={10} xxl={4} className="m-xl-auto m-xxl-0">
                        <h2>TekRevol’s Software Development Services in Florida </h2>
                        <p className="impro_para">Start your innovative journey with TekRevol's custom software and application solutions, tailor-made to improve your digital world.</p>
                        <p className="impro_para">Fuel your business with pioneering technology and imagination, certifying unequaled success and market productivity. We function as your holistic development partner, dedicated to taking your business to the stratosphere.</p>
                        <p className="impro_para">Here are the software development services that we offer in Florida:</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
                        <div className="stack_box">
                            {StackItem.map((item, index) => (
                                <div className="stack_item" key={index}>
                                    <div className="stack_title">
                                        {item.icon}
                                        <h5>{item.title}</h5>
                                    </div>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Improvise;